import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export function fmtDate(d) {
  if (!d) return "";
  try {
    return new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return d;
  }
}

export default function PostCard({ post, index = 0, testid }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.6, delay: (index % 3) * 0.06, ease: [0.16, 1, 0.3, 1] }}
      className="h-full"
    >
      <Link
        to={`/writing/${post.slug}`}
        data-testid={testid || (post.type === "paper" ? "research-card" : "blog-card")}
        className="group flex h-full flex-col border border-line bg-white transition-colors duration-300 hover:border-blue"
      >
        {post.cover_url && (
          <div className="relative aspect-[16/9] overflow-hidden">
            <img
              src={post.cover_url}
              alt=""
              className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
            />
          </div>
        )}
        <div className="flex flex-1 flex-col gap-4 p-6 sm:p-8">
          <div className="flex items-center justify-between text-[10px] font-semibold uppercase tracking-[0.2em]">
            <span className="text-blue">{post.type === "paper" ? "Research Paper" : "Essay"}</span>
            <span className="text-navy-mute">{post.category}</span>
          </div>
          <h3 className="font-serif text-xl leading-snug text-navy transition-colors duration-300 group-hover:text-blue sm:text-2xl">
            {post.title}
          </h3>
          <p className="line-clamp-3 text-sm leading-relaxed text-navy-soft">{post.excerpt}</p>
          <div className="mt-auto flex items-center justify-between border-t border-line pt-4 text-[10px] font-semibold uppercase tracking-[0.18em] text-navy-mute">
            <span>{fmtDate(post.date)}</span>
            <span>{post.read_time} min read</span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}